import { motion } from 'motion/react';
import styles from './NewRecord.module.css';

export const NewRecord = ({ noiseLevel, deltaDuration }) => {
  let textNoiseLevel = noiseLevel?.split('');

  return (
    <div className={styles.record}>
      <motion.div
        initial={{ scale: 0 }}
        animate={{
          scale: [
            0, 0.92, 0.81, 0.94, 0.83, 0.96, 0.85, 0.98, 0.87, 1, 0.81, 0.94,
            0.83, 0.96, 0.85, 0.98, 0.87, 1,
          ],
          transition: {
            scale: { duration: 4, delay: 2 + deltaDuration / 1000 },
            times: [
              0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65,
              0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1,
            ],
            ease: 'easeIn',
          },
        }}
        className={styles.numRecord}
      >
        {textNoiseLevel.map((num, idx) => (
          <div key={idx} className={`${num === '.' ? styles.comma : ''}`}>
            {num}
          </div>
        ))}
      </motion.div>
    </div>
  );
};
